// extracted by mini-css-extract-plugin
module.exports = {"socials":"SocialMediaShare_socials__xmceZ","icon":"SocialMediaShare_icon__ljPEY","social":"SocialMediaShare_social__qqmkN"};